module.exports = __webpack_public_path__ + "static/media/double-shot.70211522.svg";